// extracted by mini-css-extract-plugin
export default {"navbar":"navbars_navbar__3IQRW","navItem":"navbars_navItem__1mEHT","userNavbar__button":"navbars_userNavbar__button__D8dU2"};